import { z } from 'zod';

/**
 * TanStack Router's default `parseSearch` + `qss` decoding turns `crash=1`
 * into the number `1`. Plain `z.literal('1')` then fails validation.
 * Anything other than `1` / `'1'` is treated as absent so incidental values
 * do not fail `/dashboard` validateSearch (and surface CrashScreen in prod).
 */
export const crashPreviewSearchParamSchema = z.preprocess((val) => {
  const candidate = Array.isArray(val) ? val[0] : val;
  if (candidate === 1 || candidate === '1') return '1';
  return undefined;
}, z.literal('1').optional());
